import ENGLISH_STRINGS from "../constants/i18n/en-US";

const I18N_MAP = {
  "en-US": ENGLISH_STRINGS
};

const DEFAULT_LANGUAGE = "en-US";

function getLanguage() {
  return DEFAULT_LANGUAGE;
}

function getStrings() {
  return I18N_MAP[getLanguage] || I18N_MAP[DEFAULT_LANGUAGE];
}

function i18n(key) {
  const STRINGS = getStrings();
  return STRINGS[key] || key;
}

export default i18n;